import React from 'react'
import StaticPage from '../components/StaticPage'

function CookiePage() {
  return (
    <StaticPage title="Cookie Policy" intro="How this website uses cookies and local storage">
      <p className="muted">Last updated: August 2026. This is a starting draft. Please review with the club before relying on it.</p>

      <h2>What we use</h2>
      <p>
        This site aims to use as little as possible. We use browser storage only where it is needed
        for the site to work, for example to keep you signed in when you log in as a member.
      </p>

      <h2>No advertising or tracking cookies</h2>
      <p>
        We do not use advertising cookies, and we do not sell data to third parties. Some embedded
        content (such as the weather map) may set its own cookies; those are governed by the relevant
        provider's policy.
      </p>

      <h2>Managing cookies</h2>
      <p>
        You can clear or block cookies in your browser settings. Blocking essential cookies may stop
        parts of the members' area from working.
      </p>

      <h2>Questions</h2>
      <p>
        If you have any questions about cookies, please <a href="/contact">contact us</a>.
      </p>
    </StaticPage>
  )
}

export default CookiePage
